import ToppingModal from '../ToppingModal/topping-modal';

export default ToppingModal;